import React from 'react';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { ChartTooltip, ChartTooltipContent } from 'decap-cms-ui-next';
import { useTheme } from '@emotion/react';
import { translate } from 'react-polyglot';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { jsx as ___EmotionJSX } from "@emotion/react";
dayjs.extend(localizedFormat);
function AnalyticsChart({
  data,
  interval,
  t
}) {
  const theme = useTheme();
  const chartConfig = {
    visitors: {
      label: t('dashboard.siteAnalytics.chart.visitors'),
      color: theme.color.primary['900']
    }
  };
  function formatTooltipDateTime(value) {
    let format = 'DD MMMM YYYY, HH:mm';
    switch (interval) {
      case 'hour':
        format = 'dddd, D MMMM, HH:mm';
        break;
      case 'day':
        format = 'dddd, D MMMM';
        break;
      case 'month':
        format = 'DD MMMM YYYY';
        break;
      case 'year':
        format = 'MMMM YYYY';
        break;
    }
    return dayjs(value).format(format);
  }
  function formatLabelDateTime(value) {
    let format = 'YYYY MM DD';
    switch (interval) {
      case 'hour':
        format = 'HH:mm';
        break;
      case 'day':
        format = 'DD MMMM';
        break;
      case 'month':
      case 'year':
        format = 'MMMM YYYY';
        break;
    }
    return dayjs(value).format(format);
  }
  return ___EmotionJSX(ResponsiveContainer, {
    width: "100%",
    height: "100%"
  }, ___EmotionJSX(AreaChart, {
    accessibilityLayer: true,
    data: data
  }, ___EmotionJSX(CartesianGrid, {
    horizontal: false,
    strokeDasharray: "3 3",
    stroke: theme.color.neutral[theme.darkMode ? '200' : '400'],
    strokeWidth: 0.5
  }), ___EmotionJSX(XAxis, {
    dataKey: "date",
    orientation: "top",
    tickLine: false,
    axisLine: false,
    tickMargin: 16,
    tickFormatter: value => formatLabelDateTime(value)
  }), ___EmotionJSX(YAxis, {
    tickLine: false,
    axisLine: false,
    padding: {
      top: 32
    },
    dx: -24,
    tickFormatter: value => new Intl.NumberFormat(undefined, {
      notation: 'compact',
      compactDisplay: 'short'
    }).format(value)
  }), ___EmotionJSX(ChartTooltip, {
    cursor: {
      strokeWidth: 1,
      strokeOpacity: 1
    },
    content: ___EmotionJSX(ChartTooltipContent, {
      labelFormatter: value => formatTooltipDateTime(value),
      formatter: value => [new Intl.NumberFormat(undefined, {
        notation: 'compact',
        compactDisplay: 'short'
      }).format(value), chartConfig.visitors.label]
    }),
    contentStyle: {
      backgroundColor: theme.color.background,
      border: 'none',
      borderRadius: 8
    }
  }), ___EmotionJSX("defs", null, ___EmotionJSX("linearGradient", {
    id: "visitors",
    x1: "0",
    y1: "0",
    x2: "0",
    y2: "1"
  }, ___EmotionJSX("stop", {
    offset: "5%",
    stopColor: theme.color.primary['900'],
    stopOpacity: 0.8
  }), ___EmotionJSX("stop", {
    offset: "95%",
    stopColor: theme.color.primary['900'],
    stopOpacity: 0
  }))), ___EmotionJSX(Area, {
    dataKey: "visitors",
    type: "monotone",
    fill: "url(#visitors)",
    fillOpacity: 0.4,
    stroke: theme.color.primary['900'],
    strokeWidth: 3
  })));
}
export default translate()(AnalyticsChart);